'use client';

import Image from 'next/image';
import Link from 'next/link';
import SignupHeader from '@/components/SignupHeader';
import '@/styles/global.css';

export default function SignupPage() {
  return (
    <div className="min-h-screen bg-[#F6EFED]">
      <SignupHeader />

      <section className="join-section py-20">
        <div className="max-w-[1380px] mx-auto px-[20px]">
          <div className="grid md:grid-cols-2 gap-30">
            {/* Left Side */}
            <div className="join-left">
              <p className="eyebrow font-['Archivo',sans-serif] text-[16px] text-[#8A7296] mb-4">
                • Women-only & women-led
              </p>
              <h1 className="font-['Gotham_Rounded',sans-serif] text-[48px] font-bold text-[#2E2A3A] leading-[56px] mb-6">
                Join a women-only fitness community
              </h1>
              <p className="desc font-['Archivo',sans-serif] text-[18px] text-[#6e6672] leading-[28px]">
                Connect with certified trainers, discover inclusive gyms and
                reach your goals in a safe, empowering space.
              </p>
            </div>

            {/* Right Side */}
            <div className="join-right space-y-4">
              <Link href="/signup/gym" className="join-card flex items-center no-underline transition-colors">
                <span className="icon">
                  <Image src="/Register as a gym.svg" width={40} height={40} alt="Register as a gym" />
                </span>
                <span className="flex-1">
                  <strong className="block font-['Gotham_Rounded',sans-serif]">
                    Register as a gym
                  </strong>
                  <small className="block font-['Archivo',sans-serif]">
                    List your women-only facility
                  </small>
                </span>
                <b className="text-[32px] font-light">›</b>
              </Link>

              <Link href="/signup/trainer" className="join-card flex items-center no-underline transition-colors">
                <span className="icon">
                  <Image src="/Register as a trainer.svg" width={40} height={40} alt="Register as a trainer" />
                </span>
                <span className="flex-1">
                  <strong className="block font-['Gotham_Rounded',sans-serif]">
                    Register as a trainer
                  </strong>
                  <small className="block font-['Archivo',sans-serif]">
                    Offer your services to women clients
                  </small>
                </span>
                <b className="text-[32px] font-light">›</b>
              </Link>

              <Link href="/signup/user" className="join-card flex items-center no-underline transition-colors">
                <span className="icon">
                  <Image src="/Register as a user.svg" width={40} height={40} alt="Register as a user" />
                </span>
                <span className="flex-1">
                  <strong className="block font-['Gotham_Rounded',sans-serif]">
                    Register as a user
                  </strong>
                  <small className="block font-['Archivo',sans-serif]">
                    Find trainers and gyms near you
                  </small>
                </span>
                <b className="text-[32px] font-light">›</b>
              </Link>

              <p className="signin text-center font-['Archivo',sans-serif] text-[16px] text-[#2E2A3A] mt-8">
                Already have an account?{' '}
                <Link href="/login" className="text-[#8A7296] hover:text-[#7a647d] transition-colors font-medium">
                  Sign in
                </Link>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
